export enum UserRole {
	GOD = "GOD",
	ADMIN = "ADMIN",
	USER = "USER",
}

export enum UserStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}

export class UserDto {
	email: string;
	password: string;

	constructor() {
		this.email = "";
		this.password = "";
	}
}

export interface CreateUserDto {
	id?: string;

	email: string;

	password: string;

	permissionariesIds: string[];

	permissionaryRoles?: UserPermissionaryRole[];

	permissionaryId?: string;

	status: UserStatus;

	role: UserRole;

	createdAt?: Date;
	updatedAt?: Date;
}

export interface UserSessionDto {
	userId: string;
	accessToken: string;
	expiresIn?: string;
	role: UserRole;
	type?: string;
	permissionariesIds: string[];
	permissionaryRoles?: UserPermissionaryRole[];
	permissionaryId?: string;
	permissionaryName?: string;
}

export interface UserPermissionaryRole {
	permissionaryId: string;
	role: UserRole;
}

export interface User {
	_id: string;
	id: string;
	email: string;

	password: string;

	status: UserStatus;

	permissionariesIds: string[];

	permissionaryRoles?: UserPermissionaryRole[];

	permissionaryId?: string;

	role: UserRole;

	createdAt: string;

	updatedAt: string;
}
